import CashTamerHttpClient from './CashTamerHttpClient';
import CashTamerApiBase from './CashTamerApiBase';
import ProductResponseModel from '@/models/products/ProductResponseModel';

export default class ProductsApi extends CashTamerApiBase {
    public async getProductAsync(productId: number): Promise<ProductResponseModel> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'products/' + productId;

            const httpResponse = await httpClient.getAsync(url);

            const product = new ProductResponseModel();
            product.id = httpResponse.data.id;
            product.name = httpResponse.data.name;
            product.description = httpResponse.data.description;
            product.price = httpResponse.data.price;

            return product;
        }
        catch (err) {
            return this.handleApiError(err);
        }
    }
}
